


























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SurveyItem } from "@/models/SurveyItem";
import { ValidationProvider } from "vee-validate";
import { FontSize } from "@/views/Survey.vue";

@Component({
  components: {
    ValidationProvider
  }
})
export default class SelectItem extends Vue {
  @Prop({ type: Object })
  item!: SurveyItem;

  @Prop({ type: String, default: "" })
  value!: string;

  @Prop({ type: Number, default: 0 })
  langValue!: number;

  @Prop({ type: Number, default: 0 })
  fontSize!: FontSize;

  localValue!: string;

  created() {
    if (this.value == "") {
      this.localValue = localStorage.getItem(this.item.id) ?? "";
      this.$emit("input", this.localValue);
    } else {
      this.localValue = this.value;
    }
  }

  changeSelectListFontSize(size: FontSize) {
    let targetClass = "";
    switch (size) {
      case FontSize.small:
        targetClass = "list-item__font_size_small";
        break;
      case FontSize.medium:
        targetClass = "list-item__font_size_medium";
        break;
      case FontSize.large:
        targetClass = "list-item__font_size_large";
        break;
    }
    const elements = document.querySelectorAll(
      ".v-list-item__title, .list-item__font_size_small, .list-item__font_size_medium, .list-item__font_size_large"
    );
    elements.forEach(elem => {
      elem.classList.forEach(c => elem.classList.remove(c.toString()));
      elem.classList.add(targetClass);
    });
  }

  @Watch("fontSize")
  onFontSizeChanged(newSize: FontSize) {
    this.changeSelectListFontSize(newSize);
  }

  updateValue(value: string) {
    localStorage.setItem(this.item.id, value ?? "");
    this.localValue = value;
    this.$emit("input", value);
  }

  getItems() {
    return this.item.options.map(v => ({
      value: v.id,
      text: v.value[this.langValue].text
    }));
  }
}
